export const geoJsonFilePath = 'data/qld_lga_medium.geo.json';
export const dataFilePath = 'data/dam_data.json';



// WEBPACK FOOTER //
// ./src/config/index.js